<div class="ticket-cash-pay">
    <upp-dialog-header>
        <ion-header>
            <ion-toolbar color="warning">
                <ion-title slot="start">{{tr('@ticket_paycash_title', [ price(AmountToPay), tr('@currency') ])}}</ion-title>
                <ion-buttons slot="end">
                    <ion-button uppDataid="ticketcash-close-button" (click)="OnCloseClick()">
                        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
    </upp-dialog-header>

    <upp-dialog-content>
        <ion-item lines="none">
            <upp-input #input uppDataid="ticketcash-price-input"
                class="amount"
                type='price'
                placeholder="{{tr('@ticket_paycash_change_amount_ph')}}"
                title="{{tr('@ticket_paycash_change_amount')}}"
                [(ngModel)]="AmountPaid"
                [kiosk]="false"
            ></upp-input>
        </ion-item>
        <ion-grid class="no-select ticket-cash-pay__bills">
            <ion-row>
                <ion-col style="text-align: center" uppDataid="ticketcash-oncash_50" (click)="OnCash('100')">
                    <div class="cashbutton">100{{tr('@currency')}}</div>
                </ion-col>
                <ion-col style="text-align: center" uppDataid="ticketcash-oncash_50" (click)="OnCash('50')">
                    <div class="cashbutton">50{{tr('@currency')}}</div>
                </ion-col>
                <ion-col style="text-align: center" uppDataid="ticketcash-oncash_20" (click)="OnCash('20')">
                    <div class="cashbutton">20{{tr('@currency')}}</div>
                </ion-col>
                <ion-col style="text-align: center" uppDataid="ticketcash-oncash_10" (click)="OnCash('10')">
                    <div class="cashbutton">10{{tr('@currency')}}</div>
                </ion-col>
                <ion-col style="text-align: center" uppDataid="ticketcash-oncash_05" (click)="OnCash('5')">
                    <div class="cashbutton">5{{tr('@currency')}}</div>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div class="ticket-cash-pay__footer">
            <ion-button uppDataid="ticketcash-submit-button" size="large" expand="block" [color]="CanAccept ? 'success' : 'danger'" [disabled]="!CanAccept" (click)="OnAcceptClick()">
                <ng-container *ngIf="AmountPaid !== null">
                    <span [hidden]="(CanAccept === true)">
                        {{tr('@ticket_paycash_missing', [ price(AmountPending), tr('@currency') ])}}
                    </span>
                    <span [hidden]="(CanAccept !== true) || (AmountReturn !== 0)">
                        {{tr('@ticket_paycash_no_return')}}
                    </span>
                    <span [hidden]="(CanAccept !== true) || (AmountReturn === 0)">
                        {{tr('@ticket_paycash_return', [ price(AmountReturn), tr('@currency') ])}}
                    </span>
                </ng-container>
                <ng-container *ngIf="AmountPaid === null">
                    <span [hidden]="view.Access !== 'LOGIN'">{{tr('@ticket_paycash_accept')}}</span>
                    <span [hidden]="view.Access === 'LOGIN'">{{tr('@ticket_paycash_notify')}}</span>
                </ng-container>
            </ion-button>
            <ion-button uppDataid="ticketcash-cancel-button" expand="block" fill="clear" color="success" (click)="OnCloseClick()">
                {{tr('@ticket_paycash_cancel')}}
            </ion-button>
        </div>
        <ion-grid class="no-select ticket-cash-pay__numpad">
            <ion-row>
                <ion-col size="4" uppDataid="ticketcash-numpad_7" (click)="OnNumPad('7')">
                    <div class="numkey">7</div>
                </ion-col>
                <ion-col size="4" uppDataid="ticketcash-numpad_8" (click)="OnNumPad('8')">
                    <div class="numkey">8</div>
                </ion-col>
                <ion-col size="4" uppDataid="ticketcash-numpad_9" (click)="OnNumPad('9')">
                    <div class="numkey">9</div>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="4" uppDataid="ticketcash-numpad_4" (click)="OnNumPad('4')">
                    <div class="numkey">4</div>
                </ion-col>
                <ion-col size="4" uppDataid="ticketcash-numpad_5" (click)="OnNumPad('5')">
                    <div class="numkey">5</div>
                </ion-col>
                <ion-col size="4" uppDataid="ticketcash-numpad_6" (click)="OnNumPad('6')">
                    <div class="numkey">6</div>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="4" uppDataid="ticketcash-numpad_1" (click)="OnNumPad('1')">
                    <div class="numkey">1</div>
                </ion-col>
                <ion-col size="4" uppDataid="ticketcash-numpad_2" (click)="OnNumPad('2')">
                    <div class="numkey">2</div>
                </ion-col>
                <ion-col size="4" uppDataid="ticketcash-numpad_3" (click)="OnNumPad('3')">
                    <div class="numkey">3</div>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="4" uppDataid="ticketcash-numpad_0" (click)="OnNumPad('0')">
                    <div class="numkey">0</div>
                </ion-col>
                <ion-col size="8" uppDataid="ticketcash-numpad_B" (click)="OnNumPad('Backspace')">
                    <div class="numkey">
                        <ion-icon name="backspace-outline"></ion-icon>
                    </div>
                </ion-col>
            </ion-row>
        </ion-grid>
    </upp-dialog-content>
</div>
